import { Box, Group } from '@mantine/core'
import { Link, To, useLocation } from 'react-router-dom'
import { IconType } from 'react-icons'
import { useCustomizerActions, useCustomizerStore } from 'store/customizerStore'
import { SidebarLabel } from './SidebarLabel'
import classes from './LinkItem.module.css'

export interface LinkCollapse {
  label: string
  link: string
}

interface LinksItemProps {
  icon: IconType
  label: string
  href: To
}

export function LinkItem({ icon: Icon, label, href }: LinksItemProps) {
  const location = useLocation()
  const mobileMenuOpened = useCustomizerStore(state => state.mobileMenuOpened)
  const { toggleMobileMenu } = useCustomizerActions()
  const path = typeof href === 'string' ? href : href.pathname
  const normalizedPath = path?.replace(/\/+$/, '') || '/'
  const shouldMatchExactly =
    normalizedPath === '/' || normalizedPath === '/panel'
  const isActive = Boolean(
    normalizedPath &&
      (location.pathname === normalizedPath ||
        (!shouldMatchExactly &&
          location.pathname.startsWith(`${normalizedPath}/`))),
  )

  return (
    <Link
      className={[classes.control, isActive && 'is-active', 'nav-link-control']
        .filter(Boolean)
        .join(' ')}
      to={href}
      onClick={() => {
        if (mobileMenuOpened) toggleMobileMenu()
      }}
      aria-label={label}
      title={label}
      data-testid={`navigate-${href.toString().substring(1)}`}
    >
      <Group
        className={[classes.link, 'nav-link-content'].join(' ')}
        justify="space-between"
        gap={0}
        wrap="nowrap"
      >
        {href && (
          <Box className={classes.linkContent}>
            {Icon && <Icon size={24} />}
            <SidebarLabel
              label={label}
              className={[classes.navLink, 'link-label'].join(' ')}
            />
          </Box>
        )}
      </Group>
    </Link>
  )
}
